const brand = [
  { name: "Alothailand", code: "ALO" },
  { name: "Banilaco", code: "BC" },
  { name: "Bodyshop", code: "BS" },
  { name: "CentralBeauty", code: "CB" },
  { name: "Clarins", code: "CR" },
  { name: "DcashPro", code: "DCASH" },
  { name: "GmHealthCheck", code: "GHC" },
  { name: "Hourglass", code: "HG" },
  { name: "Huapla", code: "HUAP" },
  { name: "Jewellista", code: "JWL" },
  { name: "KcInterFoods", code: "KCIF" },
  { name: "Kis", code: "KIS" },
  { name: "Lolane", code: "LOLANE" },
  { name: "Mille", code: "ML" },
  { name: "Nissin", code: "NS" },
  { name: "Samyanmitrtown", code: "SYM" },
  { name: "Seasun", code: "SEASUN" },
  { name: "Silomedge", code: "SE" },
  { name: "Snakebrandfamily", code: "SNB" },
  { name: "Thaniyagroup", code: "TG" },
  { name: "Yongcharoen", code: "YCR" },
  { name: "YugenThailand", code: "YGT" },
  { name: "Fatcat", code: "FC" },
  { name: "BrootThailand", code: "BT" },
  { name: "bdmswellness", code: "BDMS" },
  { name: "BeautyBuffet", code: "BBFT45DB9GK8RENS0" },
  { name: "doikham", code: "DK" },
  { name: "innepetfood", code: "INPF" },
  { name: "ipst", code: "IPST" },
  { name: "smeg", code: "SMEG" },
  { name: "thewhoo", code: "TW" },
  { name: "costhailand", code: "COS" },
  { name: "orlebarbrownthailand", code: "OB" },
  { name: "skinprorx", code: "SP" },
  { name: "dcrm2", code: "DCRM2" },
  { name: "dcrm3", code: "DCRM3" },
  { name: "dcrm4", code: "DCRM4" },
  { name: "dcrm5", code: "DCRM5" },
  { name: "dcrm6", code: "DCRM6" },
  { name: "PettoVille", code: "PV" },
  { name: "Merge", code: "MERGE" },
  { name: "dcrm8", code: "DCRM8A9T6BpQ3W7X2Zm" },
  { name: "mlbthailand", code: "MLB27HZ5LM3QTNC8" },
  { name: "calvinklein", code: "CK8ZR1VKC9TQME4" },
  { name: "polorl", code: "PO6GV1HQC8ZJTR4" },
  { name: "paulsmith", code: "PS3MP7KVR9ZQX2" },
  { name: "crmdemo", code: "CRM8FR5HTC1LJ9Y" },
  { name: "giorgioarmanith", code: "GAN9LD2XQF7WME3" },
  { name: "armani", code: "AN7KP3ZMD9QWLE" },
  { name: "dcrm9", code: "DCRM9K7X3NdL9Q2VmTa" },

  {
    name: "laderachth",
    code: "LD",
  },

  {
    name: "dcrm7",
    code: "DCRM7X7K2LmP9Q8W3V",
  },
  {
    name: "aesop",
    code: "AS9XT2FVL7MQRA",
  },
  {
    name: "alosingapore",
    code: "ALS7KP9LQM2XATR",
  },

  {
    name: "onsingapore",
    code: "ON3PD7KTF5ZBQL2",
  },
  {
    name: "onthailand",
    code: "OTH4VMQZL9RTB3E",
  },
  {
    name: "peaksportthailand",
    code: "PKT7KD2XMQ9TPAL",
  },
  {
    name: "primagold",
    code: "PG4NB8ZWC1JYKE",
  },
  {
    name: "tommyhilfiger",
    code: "TH94XK2PB7WJRE6",
  },
  {
    name: "chupachups",
    code: "CHUPS7KXWPL2MQZ8E",
  },
  {
    name: "goldpetshop",
    code: "CHUPS7KXWPL2MQZ8E",
  },
];

const getBrandCode = () => {
  let host = window.location.hostname;
  let b = host.split("-")[0];
  let codeIndex = brand.find((el) => el.name.toLowerCase() == b);
  if (codeIndex) return codeIndex.code;
  return "DEV";
};
export { getBrandCode };
